<script>
import { provide, ref, inject } from 'vue-demi'
import { PROVIDE_KEYS } from './consts'

export default {
  setup () {
    const attachments = ref([])
    const inspection = ref({})
    provide(PROVIDE_KEYS.ATTACHMENTS, attachments)
    provide(PROVIDE_KEYS.INSPECTION, inspection)
  },
  render () {
    const slot = this.$scopedSlots.default()
    return Array.isArray(slot) ? slot[0] : slot
  },
}

/**
 * @typedef Attachment
 * @prop {string} batchNum
 * @prop {string} checksum
 * @prop {string} createdAt
 * @prop {string} createdBy
 * @prop {object} creator
 * @prop {string?} deletedAt
 * @prop {string?} description
 * @prop {string?} effectiveDate
 * @prop {string?} endDate
 * @prop {string} filename
 * @prop {string} filepath
 * @prop {number} filesize
 * @prop {string} id
 * @prop {{ checksum: string, token: string  } & Record<string, any>} metaData
 * @prop {string} mimetype
 * @prop {string} order
 * @prop {string} source
 * @prop {string} updatedAt
 * @prop {string} version
 */
/**
 * @type {() => Ref<Attachment[]>}
 */
export const useAttachments = () => {
  return inject(PROVIDE_KEYS.ATTACHMENTS, [])
}
export const useCurrentInspection = () => {
  return inject(PROVIDE_KEYS.INSPECTION, ref({}))
}
</script>
